import { IApplicationState } from '../../types/redux';

export function deviceTypeReducer(state: IApplicationState['deviceType'] = 'desktop'): IApplicationState['deviceType'] {
  return state;
}
